// Core Imports
import React from "react";

// Custom Imports
import "./public/assets/css/bootstrap.min.css";
import "./public/assets/css/style.css";
import "./index.css";
import 'react-toastify/dist/ReactToastify.css';
import StudentAuth from "./pages/student/StudentAuth";
import Signup from "./pages/student/SignupStudentDetailStep";
import ForgetPassword from "./pages/student/ForgetPassword";
import Error from "./pages/Error";
import {Switch, Route,Redirect} from "react-router-dom";
import TutorSigin from "./pages/tutor/TutorSigin";
import TutorSigup from "./pages/tutor/TurtorSignup";
import TutorAuth from "./pages/tutor/TutorAuth";
import TutorProfileSignup from "./pages/tutor/TutorProfileSignup";
import TutorForgetPas from "./pages/tutor/TutorForgetPas";
import asyncComponentHOC from "./hoc/asynccomponent";
import {ToastContainer} from 'react-toastify';
import {Offline, Online} from "react-detect-offline";
import NoInterne from './components/Offline/Offline'
import InternetOnline from "./components/Offline/Online";
import Authorize from "./pages/Authorize";
import Verify from "./pages/Verify";

const asyncStudentSignupStep2 = asyncComponentHOC(() => {
    return import("./pages/student/SignupSchoolDetailStep");
});
const asyncStudentSignupStep3 = asyncComponentHOC(() => {
    return import("./pages/student/SignupPasswordStep");
});
const isAuthenticated=!!localStorage.getItem('access_token');
const isTutorAuthenticated=!!localStorage.getItem('tutor_access_token');
// console.log("isAuthenticated",isAuthenticated)
// console.log("isTutorAuthenticated",isTutorAuthenticated)
function App() {
    return (
        <>
            {/*<Offline><NoInterne/></Offline>*/}
            {/*<Online><InternetOnline/></Online>*/}
            <ToastContainer/>
            <Switch>
                <Route exact path="/authorize" component={Authorize}/>
                {/*<Route exact path="/" component={StudentAuth}/>*/}
                <Route
                    exact
                    path="/"
                    render={() => {
                        return (
                            isAuthenticated ?
                                <Redirect to="/authorize" /> :
                                <StudentAuth/>
                        )
                    }}
                />
                <Route exact path="/student-signin" component={StudentAuth}/>
                <Route exact path="/student-signup" component={Signup}/>
                <Route
                    exact
                    path="/student-school-details"
                    component={asyncStudentSignupStep2}
                />
                <Route
                    exact
                    path="/student-account-password"
                    component={asyncStudentSignupStep3}
                />
                <Route exact path="/forgetPassword" component={ForgetPassword}/>
                <Route exact path="/tutor" component={TutorSigin}/>
                {/*<Route exact path="/pro" component={TutorAuth}/>*/}

                <Route
                    exact
                    path="/pro"
                    render={() => {
                        return (
                            isTutorAuthenticated ?
                                <Redirect to="/authorize?login=true&login_role=professor" /> :
                                <TutorAuth/>
                        )
                    }}
                />
                <Route exact path="/tutor-signin" component={TutorAuth}/>
                <Route exact path="/tutorSignup" component={TutorSigup}/>
                <Route
                    exact
                    path="/tutorSignupProfile"
                    component={TutorProfileSignup}
                />
                <Route exact path="/tutor-forget-pass" component={TutorForgetPas}/>
                <Route path="/code" component={Verify}/>
                <Route path="/pro/code" component={Verify}/>
                <Route component={Error}/>
            </Switch>
        </>
    );
}

export default App;